module.exports = __webpack_public_path__ + "img/quest_visualisation_gold_task.0d880318.svg";